/**
 * @flow
 * Created by neo on 01.06.17.
 */

import {observable, computed, action} from 'mobx';

export default class PromoCode {
  @observable id: numeric;
  @observable code: string = '';
  @observable currency_code: string;
  @observable valid_until: Date;
  @observable discount_abs: number;
  @observable discount_percent: number;


  constructor(json?: any) {
    if(json) {
      this.id = json.id;
      this.code = json.code || '';
      this.currency_code = json.currency_code;
      this.valid_until = json.valid_until ? new Date(json.valid_until) : null;
      this.discount_abs = json.discount_abs;
      this.discount_percent = json.discount_percent;
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/Store/PromoCode.js